import React, { Component } from 'react';
import { Table } from 'react-bootstrap'
import { connect } from 'react-redux';
import { formatCurrencyByLocale } from '@renenet/shared/src/utils/currencyUtils';
import { AssetGroups } from '@renenet/shared/src/constants/assetGroups';
import { computeGroupSummary } from '@renenet/shared/src/utils/groupingUtils';

function mapStateToProps(state) {
  return {
    assetSummary: state.assetInfo.assetSummary,
    assetGroup: state.assetInfo.assetGroup,
    currencyInfo: state.currencyInfo
  }
}

class AssetTypeSummaryTable extends Component {
  render() {
    const { assetSummary, assetGroup, currencyInfo } = this.props;
    const groupSummary = computeGroupSummary(assetSummary, assetGroup, currencyInfo);
    const header = assetGroup === AssetGroups.CURRENCY ? 'Currency' : 'Type';
    return (
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            {[header, 'Balance'].map(c => <th key={c}>{c}</th>)}
          </tr>
        </thead>
        <tbody>
          {groupSummary.map(r =>
            <tr key={r[0]}>{r.map((c, cidx) => <td key={cidx}>{cidx === 0 ? c : formatCurrencyByLocale(currencyInfo.locale, currencyInfo.aggregationCurrency, c)}</td>)}</tr>
          )}
        </tbody>
      </Table>
    );
  }
}

export default connect(mapStateToProps)(AssetTypeSummaryTable);
